import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-element-file-upload" }
const _hoisted_2 = ["multiple", "id", "accept", "aria-invalid", "aria-required"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "form-element-file-upload__input-label-drop" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-element-file-upload__input-label-finder" }, "Datei auswählen", -1)
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "form-element-file-upload__input-label-success-icon" }
const _hoisted_8 = { class: "form-element-file-upload__input-label-success" }
const _hoisted_9 = { "aria-live": "assertive" }
const _hoisted_10 = {
  key: 0,
  class: "form-element-file-upload__error"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "form-element-file-upload__success"
}
const _hoisted_13 = {
  key: 0,
  class: "form-element-file-upload__success-image"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "form-element-file-upload__success-name" }
const _hoisted_16 = { class: "form-element-file-upload__success-delete" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconDropFile = _resolveComponent("IconDropFile")!
  const _component_IconSuccessCheck = _resolveComponent("IconSuccessCheck")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_IconTrashCan = _resolveComponent("IconTrashCan")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "form-element-file-upload__input",
      onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
      onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
      onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
    }, [
      _createElementVNode("input", {
        type: "file",
        multiple: _ctx.multiple,
        id: _ctx.id,
        ref: "fileUpload",
        class: "form-element-file-upload__input-field",
        accept: _ctx.validFileFormats,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        "aria-invalid": _ctx.fieldError,
        "aria-required": _ctx.fieldIsRequired
      }, null, 40, _hoisted_2),
      (!_ctx.uploadSuccess)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.id,
            class: _normalizeClass(["form-element-file-upload__input-label", {
          'form-element-file-upload__input-label--active': _ctx.dropAreaActive,
          'form-element-file-upload__input-label--error': _ctx.fieldError,
        }])
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_IconDropFile, { class: "form-element-file-upload__input-icon" }),
              _createTextVNode("Drag & Drop oder")
            ]),
            _hoisted_5
          ], 10, _hoisted_3))
        : (_openBlock(), _createElementBlock("label", {
            key: 1,
            for: _ctx.id,
            class: _normalizeClass(["form-element-file-upload__input-label form-element-file-upload__input-label--success", {
          'form-element-file-upload__input-label--active': _ctx.dropAreaActive,
        }])
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_IconSuccessCheck)
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.message), 1)
          ], 10, _hoisted_6))
    ], 32),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.hasError && _ctx.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_MessageBox, { content: _ctx.message }, null, 8, ["content"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "form-element-file-upload__caption",
      innerHTML: _ctx.caption
    }, null, 8, _hoisted_11),
    (_ctx.uploadSuccess || _ctx.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.showPreviewImageAfterUpload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.value,
                  alt: "Uploaded file preview"
                }, null, 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.fileName), 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args))),
              type: "button",
              class: "link"
            }, [
              _createVNode(_component_IconTrashCan, { class: "form-element-file-upload__success-delete-icon" })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}